export default __webpack_public_path__ + "static/media/Fulfillment_Empacamos-11.aa471d51.svg";